var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8064 30.4276C21.2364 24.5442 27 16.8896 27 11.1111C27 4.97461 22.0751 0 16 0C9.92487 0 5 4.97461 5 11.1111C5 16.8682 10.7211 24.4773 15.1444 30.3604C15.4359 30.7481 15.7218 31.1283 16 31.5C16.2626 31.1499 16.5319 30.7922 16.8064 30.4276ZM16 15.9883C18.7614 15.9883 21 13.7497 21 10.9883C21 8.22686 18.7614 5.98828 16 5.98828C13.2386 5.98828 11 8.22686 11 10.9883C11 13.7497 13.2386 15.9883 16 15.9883Z",
  className: "widget_icon_line"
})));
export { SvgMap as ReactComponent };
export default __webpack_public_path__ + "map.19b8dbe60bc7192bb6e4d292c1ce4c34.svg";